module.exports = __webpack_public_path__ + "static/media/expert (3).ef646de4.png";